module.exports = __webpack_public_path__ + "img/276.1a67b02a.png";